var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsappStatusAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.8,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    color: "currentColor",
    "aria-hidden": "true",
    focusable: "false",
    style: {
      color: "currentColor"
    },
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69 8.56a9 9 0 0 0 -.69 3.44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69 15.44a9 9 0 0 0 1.95 2.92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56 20.31a9 9 0 0 0 3.44 .69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.31 15.44a9 9 0 0 0 .69 -3.44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.25,
    fill: "currentColor",
    stroke: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappStatusAd);
export default __webpack_public_path__ + "static/media/whatsapp-status-ad.d05231e435def73a64b03a5d92abcbcf.svg";
export { ForwardRef as ReactComponent };